const FADE_MS = 200;
const EASING = 'ease';
const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const resolveEl = (el) => {
    const node = typeof el === 'string' ? document.querySelector(el) : el;
    return node instanceof HTMLElement ? node : null;
};
export const fadeIn = (el, display = 'block') => {
    const element = resolveEl(el);
    if (!element)
        return;
    element.style.display = display;
    if (reducedMotion()) {
        element.style.opacity = '1';
        return;
    }
    element.style.opacity = '0';
    element.style.willChange = 'opacity';
    element.style.transition = `opacity ${FADE_MS}ms ${EASING}`;
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            element.style.opacity = '1';
        });
    });
    const cleanup = (e) => {
        if (e.propertyName !== 'opacity')
            return;
        element.removeEventListener('transitionend', cleanup);
        element.style.willChange = '';
        element.style.transition = '';
    };
    element.addEventListener('transitionend', cleanup);
};
export const fadeOut = (el) => {
    const element = resolveEl(el);
    if (!element)
        return Promise.resolve();
    return new Promise((resolve) => {
        if (reducedMotion()) {
            element.style.opacity = '0';
            element.style.display = 'none';
            resolve();
            return;
        }
        element.style.willChange = 'opacity';
        element.style.transition = `opacity ${FADE_MS}ms ${EASING}`;
        element.offsetHeight;
        element.style.opacity = '0';
        const cleanup = (e) => {
            if (e.propertyName !== 'opacity')
                return;
            element.removeEventListener('transitionend', cleanup);
            element.style.willChange = '';
            element.style.transition = '';
            element.style.display = 'none';
            resolve();
        };
        element.addEventListener('transitionend', cleanup);
    });
};
export const observeVisibility = (selector, className = 'visible', threshold = 0.3, removeOnHide = false, rootMargin = '0px', callback) => {
    const items = document.querySelectorAll(selector);
    if (!items.length)
        return;
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add(className);
                callback?.(entry.target);
                if (!removeOnHide)
                    obs.unobserve(entry.target);
            }
            else if (removeOnHide) {
                entry.target.classList.remove(className);
            }
        });
    }, { threshold, rootMargin });
    items.forEach((item) => observer.observe(item));
};
export const initBgVideoReveal = (selector) => {
    const INIT_ATTR = 'data-bg-video-reveal-init';
    const init = () => {
        document.querySelectorAll(selector).forEach((video) => {
            if (video.hasAttribute(INIT_ATTR))
                return;
            video.setAttribute(INIT_ATTR, '');
            if (reducedMotion())
                return;
            const reveal = () => fadeIn(video);
            if (video.readyState >= 3) {
                reveal();
                return;
            }
            video.addEventListener('canplay', reveal, { once: true });
        });
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    }
    else {
        init();
    }
    if (window.acf) {
        window.acf.addAction('render_block_preview', init);
    }
};
export const initAppHeight = (headerSelector = '.js--site-header') => {
    const doc = document.documentElement;
    const header = document.querySelector(headerSelector);
    const update = () => {
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
        if (header) {
            doc.style.setProperty('--header-height', `${header.offsetHeight}px`);
        }
    };
    update();
    window.addEventListener('resize', update, { passive: true });
};
